import styles from "./PlayerList.module.css"
import { Paper } from "../../../components/content/Paper"
import { HeaderTable3 } from "../../../components/content/table/header-table-3"
import { TableLine } from "./table-line"
import { PlayersList } from "../lib/players"
import { Link } from "react-router-dom"
import React from "react"
interface Props {
  players: PlayersList[]
}
function PlayerList(props: Props) {
  return (
    <React.Fragment>
      <Paper>
        <div className={styles.root}>
          <HeaderTable3 title={["Country", "Player name", "Status"]}></HeaderTable3>
          <div className={styles.table}>
            {props.players &&
              props.players.map((player, index) => (
                <Link key={index} to={"/" + player.deviceID}>
                  {" "}
                  <TableLine className={index % 2 === 0 ? styles.bg : ""} key={index} player={player}></TableLine>
                </Link>
              ))}
          </div>
        </div>
      </Paper>
    </React.Fragment>
  )
}

export default PlayerList
